/* KIMU 2.0 — "Modo Cyber" (tema borrador Cyber 2026)
   ---------------------------------------------------------------
   Lee assets/cyber-config.json y decide el estado con la hora del navegador:
     (antes de "aviso_desde"       -> tienda normal, igual que post)
     pre  = de "aviso_desde" a "inicio" -> avisos "Se viene"
     live = de "inicio" a "fin"    -> % y precio Cyber (solo se MUESTRA: el descuento lo cobra el carro)
     post = despues de "fin"       -> todo igual que el tema normal (se quita todo lo Cyber)
   Prueba: ?cyber_now=2026-10-05T10:00:00-03:00 (queda en sessionStorage al navegar; ?cyber_now=off lo borra).
   Sin JS no aparece nada Cyber: los bloques Cyber vienen con [hidden] desde Liquid.
*/
(function () {
  'use strict';

  var root = document.documentElement;
  var TXT = window.KIMU_CYBER_TXT || {};
  var CFG_URL = root.getAttribute('data-cy-config');
  var cfg = null;
  var state = null;
  var DAY = 86400000;

  function unwait() { root.classList.remove('cy-wait'); root.classList.remove('cy-wait-b'); }
  if (!CFG_URL || !window.fetch || !document.querySelector) { unwait(); return; }

  /* ---------- hora (real o forzada con ?cyber_now=) ---------- */
  function forcedNow() {
    var q = null;
    if (root.getAttribute('data-cy-off') === '1') { try { sessionStorage.removeItem('cyber_now'); } catch (e) {} return null; }
    try { q = new URLSearchParams(window.location.search).get('cyber_now'); } catch (e) { q = null; }
    try {
      if (q !== null && /^(off|real|0|)$/i.test(q)) { sessionStorage.removeItem('cyber_now'); q = null; }
      else if (q) { q = q.replace(/ /g, '+'); sessionStorage.setItem('cyber_now', q); }
      else { q = sessionStorage.getItem('cyber_now'); }
    } catch (e) { /* sessionStorage bloqueado: usa solo el parametro */ }
    if (q) { var t = Date.parse(q); if (!isNaN(t)) return t; }
    return null;
  }
  var FORCED = forcedNow();
  function now() { return FORCED !== null ? FORCED : Date.now(); }

  /* ---------- reglas ---------- */
  function ts(s) { var t = Date.parse(s); return isNaN(t) ? null : t; }
  function stateAt(t) {
    var i = ts(cfg.inicio), f = ts(cfg.fin);
    if (i === null || f === null) return 'post';
    var a = ts(cfg.aviso_desde);
    if (a !== null && t < a) return 'post'; // antes de los avisos: tienda normal
    if (t < i) return 'pre';
    if (t <= f + 999) return 'live';
    return 'post';
  }
  function rules(h) { return (cfg.productos && cfg.productos[h]) || []; }
  function activeRule(h, t) {
    var r = rules(h);
    for (var k = 0; k < r.length; k++) {
      var d = ts(r[k].desde), a = ts(r[k].hasta);
      if (d !== null && a !== null && t >= d && t <= a + 999 && r[k].pct > 0) return r[k];
    }
    return null;
  }
  function skuOk(rule, sku) { return !rule.skus || (sku && rule.skus.indexOf(sku) !== -1); }
  function pesos(cents) { return Math.round((cents || 0) / 100); }
  function cyberPesos(cents, pct) { var p = pesos(cents); return p - Math.round(p * pct / 100); }
  function money(p) { return '$' + String(p).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function strikePesos(v) {
    if (cfg.tachado === 'compare_at' && v.c && v.c > v.p) return pesos(v.c);
    return pesos(v.p);
  }
  function note(h) { return (cfg.nota_producto && cfg.nota_producto[h]) || ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* Decide que mostrar para un producto/variante. Devuelve null (normal) o {pct, now, was} o {note} */
  function priceInfo(h, v, t) {
    var rule = activeRule(h, t);
    if (!rule || !v) return null;
    if (!skuOk(rule, v.s)) return note(h) ? { note: note(h) } : null;
    return { pct: rule.pct, now: cyberPesos(v.p, rule.pct), was: strikePesos(v) };
  }

  function badgeLive(pct) {
    var b = document.createElement('span');
    b.className = 'cy-badge';
    b.setAttribute('data-cy-added', '');
    b.innerHTML = '<b>&minus;' + pct + '%</b><i>' + esc(TXT.liveLabel || 'Cyber') + '</i>';
    b.setAttribute('aria-label', (TXT.liveLabel || 'Cyber') + ' ' + pct + '% de descuento');
    return b;
  }
  function badgePre() {
    var b = document.createElement('span');
    b.className = 'cy-pill';
    b.setAttribute('data-cy-added', '');
    b.textContent = TXT.preBadge || 'Cyber · dom 20:00';
    return b;
  }

  /* ---------- limpieza (volver al estado normal) ---------- */
  function restore(scope) {
    scope.querySelectorAll('[data-cy-added]').forEach(function (el) { el.parentNode && el.parentNode.removeChild(el); });
    scope.querySelectorAll('[data-cy-hid]').forEach(function (el) { el.hidden = false; el.removeAttribute('data-cy-hid'); });
    scope.querySelectorAll('[data-cy-orig]').forEach(function (el) {
      // si otro script reescribio el elemento (p. ej. product-form.js al cambiar de variante), su contenido actual ya es el normal
      if (el.innerHTML === el._cySet) el.innerHTML = el.getAttribute('data-cy-orig');
      el.removeAttribute('data-cy-orig');
      el._cySet = null;
    });
  }
  function hide(el) { if (el && !el.hidden) { el.hidden = true; el.setAttribute('data-cy-hid', ''); } }
  function setHTML(el, html) {
    if (!el) return;
    if (!el.hasAttribute('data-cy-orig')) el.setAttribute('data-cy-orig', el.innerHTML);
    el.innerHTML = html;
    el._cySet = el.innerHTML;
  }

  /* ---------- tarjetas de producto ---------- */
  function cardData(card) {
    var j = card.querySelector('script[data-cy-json]');
    return j ? readJSON(j) : null;
  }
  function badgesBox(card) {
    var media = card.querySelector('.product-card__media');
    if (!media) return null;
    var box = media.querySelector('.product-card__badges');
    if (!box) {
      box = document.createElement('div');
      box.className = 'product-card__badges';
      box.setAttribute('data-cy-added', '');
      media.insertBefore(box, media.firstChild);
    }
    return box;
  }
  function hideOfertaBadges(box) {
    if (!box) return;
    box.querySelectorAll('.product-card__badge').forEach(function (b) {
      if (/^\s*oferta\s*$/i.test(b.textContent)) hide(b);
    });
  }
  function doCard(card, st, t) {
    if (card.getAttribute('data-cy-state') === st) return;
    restore(card);
    card.setAttribute('data-cy-state', st);
    if (st === 'post') return;
    var d = cardData(card);
    if (!d || !d.h || d.a === false || !rules(d.h).length) return;
    var priceEl = card.querySelector('.product-card__price');

    if (st === 'pre') {
      var box0 = badgesBox(card);
      if (box0) { hideOfertaBadges(box0); box0.insertBefore(badgePre(), box0.firstChild); }
      return;
    }
    // live: variante base
    var rule = activeRule(d.h, t);
    if (!rule) return;
    var vs = d.v || [];
    var base = null, k;
    if (rule.skus) {
      for (k = 0; k < vs.length; k++) { if (vs[k].a) { base = vs[k]; break; } }
      base = base || vs[0];
    } else {
      for (k = 0; k < vs.length; k++) { if (vs[k].p === d.p && vs[k].a) { base = vs[k]; break; } }
      if (!base) for (k = 0; k < vs.length; k++) { if (vs[k].p === d.p) { base = vs[k]; break; } }
      base = base || { p: d.p, c: 0, s: null, a: true };
    }
    var info = priceInfo(d.h, base, t);
    if (!info || !priceEl) return;
    if (info.note) {
      var n = document.createElement('span');
      n.className = 'cy-card-note'; n.setAttribute('data-cy-added', ''); n.textContent = info.note;
      priceEl.parentNode.insertBefore(n, priceEl.nextSibling);
      return;
    }
    var box = badgesBox(card);
    if (box) { hideOfertaBadges(box); box.insertBefore(badgeLive(info.pct), box.firstChild); }
    var desde = priceEl.querySelector('small') ? '<small>' + esc(priceEl.querySelector('small').textContent) + '</small>' : '';
    var p = document.createElement('span');
    p.className = 'product-card__price cy-price';
    p.setAttribute('data-cy-added', '');
    p.innerHTML = desde + '<span class="cy-now">' + money(info.now) + '</span>' +
      (info.was > info.now ? '<s class="cy-was"><span class="cy-sr">antes </span>' + money(info.was) + '</s>' : '');
    priceEl.parentNode.insertBefore(p, priceEl);
    hide(priceEl);
  }

  /* ---------- pagina de producto ---------- */
  var pdp = null;
  function pdpVariant() {
    if (!pdp) return null;
    var input = pdp.form ? pdp.form.querySelector('input[name="id"]') : null;
    var id = input ? String(input.value) : null;
    var vs = pdp.data.v || [];
    for (var k = 0; k < vs.length; k++) if (String(vs[k].id) === id) return vs[k];
    return vs[0] || null;
  }
  function doPDP(st, t) {
    if (!pdp) return;
    restore(pdp.info);
    var sticky = document.querySelector('.sticky-atc');
    if (sticky) restore(sticky);
    pdp.info.classList.remove('cy-pdp-live');
    if (st === 'post' || !rules(pdp.data.h).length) return;
    var priceBox = pdp.info.querySelector('.pdp__price');
    if (!priceBox) return;

    if (st === 'pre') {
      var pre = document.createElement('div');
      pre.className = 'cy-pdp cy-pdp--pre';
      pre.setAttribute('data-cy-added', '');
      pre.innerHTML = '<span class="cy-pill">' + esc(TXT.preBadge || 'Cyber · dom 20:00') + '</span>' +
        (TXT.prePdpNote ? '<span class="cy-pdp__prenote">' + esc(TXT.prePdpNote) + '</span>' : '');
      priceBox.parentNode.insertBefore(pre, priceBox.nextSibling);
      return;
    }

    // live
    var v = pdpVariant();
    var info = priceInfo(pdp.data.h, v, t);
    if (info && info.note) {
      var nn = document.createElement('p');
      nn.className = 'cy-pdp__note'; nn.setAttribute('data-cy-added', ''); nn.textContent = info.note;
      priceBox.parentNode.insertBefore(nn, priceBox.nextSibling);
    } else if (info) {
      var box = document.createElement('div');
      box.className = 'cy-pdp';
      box.setAttribute('data-cy-added', '');
      box.innerHTML =
        '<div class="cy-pdp__row">' +
          '<span class="cy-pdp__now">' + money(info.now) + '</span>' +
          (info.was > info.now ? '<s class="cy-pdp__was"><span class="cy-sr">antes </span>' + money(info.was) + '</s>' : '') +
          '<span class="cy-badge cy-badge--inline"><b>&minus;' + info.pct + '%</b><i>' + esc(TXT.liveLabel || 'Cyber') + '</i></span>' +
        '</div>' +
        (TXT.pdpNote ? '<p class="cy-pdp__note">' + esc(TXT.pdpNote) + '</p>' : '');
      priceBox.parentNode.insertBefore(box, priceBox);
      hide(priceBox);
      pdp.info.classList.add('cy-pdp-live');
      // precio en la barra fija del celular
      var sp = document.querySelector('.sticky-atc [data-sticky-price]');
      if (sp) setHTML(sp, '<span class="cy-now">' + money(info.now) + '</span> <s class="cy-was">' + money(info.was) + '</s>');
    }
    // botones de tamano (50 / 100 ml)
    pdp.info.querySelectorAll('.pdp__variant[data-variant-id]').forEach(function (btn) {
      var vv = null, vs = pdp.data.v || [];
      for (var k = 0; k < vs.length; k++) if (String(vs[k].id) === String(btn.getAttribute('data-variant-id'))) vv = vs[k];
      var inf = priceInfo(pdp.data.h, vv, t);
      if (!inf || inf.note) return;
      var ps = btn.querySelector(':scope > span');
      if (ps) setHTML(ps, '<span class="cy-now">' + money(inf.now) + '</span> <s class="cy-was">' + money(inf.was) + '</s>');
      var ml = parseFloat(((btn.querySelector('strong') || {}).textContent || '').replace(',', '.'));
      var per = btn.querySelector('.pdp__perml');
      if (per && ml > 0) {
        var rest = per.textContent.indexOf('·') !== -1 ? ' ·' + per.textContent.split('·').slice(1).join('·') : '';
        setHTML(per, esc(money(Math.round(inf.now / ml)) + '/ml' + rest));
      }
    });
    // boton "Agregar decant 3 ml · $x"
    pdp.info.querySelectorAll('[data-cy-decant-price]').forEach(function (el) {
      var h = el.getAttribute('data-cy-handle'), c = parseInt(el.getAttribute('data-cy-cents'), 10);
      var inf = priceInfo(h, { p: c, c: 0, s: null, a: true }, t);
      if (inf && !inf.note) setHTML(el, money(inf.now) + ' <s class="cy-was">' + money(inf.was) + '</s>');
    });
  }

  /* ---------- bloques de seccion (anuncios, hero, banner) ---------- */
  function doBlocks(st) {
    document.querySelectorAll('[data-cy-show]').forEach(function (el) {
      el.hidden = (' ' + el.getAttribute('data-cy-show') + ' ').indexOf(' ' + st + ' ') === -1;
    });
    document.querySelectorAll('[data-cy-hide]').forEach(function (el) {
      el.hidden = (' ' + el.getAttribute('data-cy-hide') + ' ').indexOf(' ' + st + ' ') !== -1;
    });
  }

  /* ---------- aplicar ---------- */
  function applyCards(t) {
    document.querySelectorAll('[data-cy-card]').forEach(function (c) { doCard(c, state, t); });
  }
  function apply() {
    var t = now();
    var st = stateAt(t);
    var changed = st !== state;
    state = st;
    root.setAttribute('data-cyber', st);
    root.classList.toggle('cy-on', st === 'pre' || st === 'live');
    doBlocks(st);
    if (changed) document.querySelectorAll('[data-cy-card]').forEach(function (c) { c.removeAttribute('data-cy-state'); });
    applyCards(t);
    doPDP(st, t);
    if (changed && typeof window.kimuAnnouncementReset === 'function') window.kimuAnnouncementReset();
    unwait();
    scheduleNext(t);
    window.kimuCyber = { state: st, now: new Date(t).toISOString(), forced: FORCED !== null, apply: apply };
  }
  var nextTimer = null;
  function scheduleNext(t) {
    if (FORCED !== null) return;
    clearTimeout(nextTimer);
    var marks = [ts(cfg.aviso_desde), ts(cfg.inicio), ts(cfg.fin) + 1000];
    Object.keys(cfg.productos || {}).forEach(function (h) {
      cfg.productos[h].forEach(function (r) { marks.push(ts(r.desde)); marks.push(ts(r.hasta) + 1000); });
    });
    var next = null;
    marks.forEach(function (m) { if (m && m > t && (next === null || m < next)) next = m; });
    if (next !== null && next - t < 2 * DAY) nextTimer = setTimeout(apply, next - t + 50);
  }

  function init() {
    var info = document.querySelector('.pdp__info');
    var pj = document.querySelector('script[data-cy-product]');
    if (info && pj) {
      var data = readJSON(pj);
      if (data) pdp = { info: info, data: data, form: info.querySelector('form[data-product-form]') };
    }
    // cambio de variante (lo emite product-form.js)
    document.addEventListener('kimu:variant-change', function () { if (cfg) doPDP(state, now()); });
    // tarjetas que llegan despues (recomendados por API, etc.)
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (!cfg || pending) return;
        pending = true;
        (window.requestAnimationFrame || setTimeout)(function () { pending = false; applyCards(now()); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  fetch(CFG_URL, { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('cfg ' + r.status); return r.json(); })
    .then(function (c) {
      cfg = c;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { init(); apply(); });
      } else { init(); apply(); }
    })
    .catch(function () { unwait(); });
})();
